import { baseMUITheme } from './theme';

export const paletteDark = {
  type: 'dark',
  background: {
    default: '#ff0000',
    paper: '#ff0000',
  },
  common: {
    black: '#ff00FF',
    white: '#00ff00',
  },
  text: {
    primary: '#ff00ff',
    secondary: '#00ff00',
    disabled: '#ff0000',
    hint: '#ff00ff',
  },
  contrastThreshold: 1,
  tonalOffset: 1,
  grey: {
    50: '#ff00ff',
    100: '#ff00ff',
    200: '#ff00ff',
    300: '#ff00ff',
    400: '#ff00ff',
    500: '#ff00ff',
    600: '#ff00ff',
    700: '#ff00ff',
    800: '#ff00ff',
    900: '#ff00ff',
    A100: '#ff00ff',
    A200: '#ff00ff',
    A400: '#ff00ff',
    A700: '#ff00ff',
  },
  getContrastText: baseMUITheme.palette.getContrastText,
  augmentColor: baseMUITheme.palette.augmentColor,
  icon: {
    main: '#ff00ff',
    dark: '#00ff00',
    light: 'ff00ff',
    contrastText: '#00ffff',
  },
  primary: {
    main: '#ff00ff',
    contrastText: '#fff',
    light: '#ff00ff',
    dark: '#ff00ff',
  },
  secondary: {
    main: '#0000ff',
    contrastText: '#0000ff',
    light: '#0000ff',
    dark: '#0000ff',
  },
  error: {
    main: '#d62f4c',
    contrastText: '#fff',
    light: '#ff00ff',
    dark: '#ff00ff',
  },
  success: {
    main: '#228833',
    dark: '#228833',
    light: '#73a87b',
    contrastText: '#fff',
  },
  info: {
    main: '#a2a2a2',
    dark: '#7c7c7c',
    light: '#a2a2a2',
    contrastText: '#fff',
  },
  warning: {
    main: '#DDAA22',
    dark: '#DDAA22',
    light: '#e4c464',
    contrastText: '#fff',
  },
  danger: {
    main: '#bb2233',
    dark: '#bb2233',
    light: '#c96d77',
    contrastText: '#fff',
  },
  divider: '#f3f3f3',
};
